<template>
    <div id="newCalendarBox" class="calendar-box" style="position: relative; height: 100%">
        <CCBlockFrame :header="{ title: appletData.name, icon: appletData.icon, more: true, code: 'LDGWAP' }">
            <div class="top">
                <table v-if="weekType" border="0" class="table-box" :style="{ 'border-spacing': bigScreen ? '10px 2px' : '10px 10px' }">
                    <tbody v-if="dateListData && dateListData.length > 0">
                        <tr :style="{ height: bigScreen ? '92px' : '68px' }">
                            <td class="select-button" style="padding: 0">
                                <div style="display: flex; width: 100%; height: 100%; align-items: center" :style="{ 'justify-content': bigScreen ? 'space-evenly' : 'space-evenly' }">
                                    <div style="width: 20px; height: 100%; cursor: pointer">
                                        <img :style="{ width: bigScreen ? '14px' : '10px', height: bigScreen ? '14px' : '10px', 'margin-top': bigScreen ? '18px' : '8px' }" src="/images/w-imgs/portal/left-o.png" @click="preWeek" />
                                    </div>
                                    <div class="showYear" :style="{ width: bigScreen ? '52px' : '50px' }" style="display: flex; flex-direction: column; height: 100%">
                                        <span v-text-lbl="'whichWeek'" :style="{ 'font-size': bigScreen ? '16px' : '14px', 'padding-top': bigScreen ? '16px' : '6px' }" style="color: #29242b; font-weight: bold; text-align: center" :num="whereWeek">第{{ whereWeek }}周</span>
                                        <!-- <span :style="{ 'font-size': bigScreen ? '14px' : '12.4898px', 'margin-top': bigScreen ? '10px' : '8px' }" style="color: rgba(0, 0, 0, 0.5); font-weight: bold; text-align: center" v-text-lbl="'numMonth'" :num="currentTime.split('-')[1]">{{ currentTime.split('-')[1] }} 月</span> -->
                                        <span :style="{ 'font-size': bigScreen ? '14px' : '12.4898px', 'margin-top': bigScreen ? '10px' : '8px' }" style="color: rgba(0, 0, 0, 0.5); font-weight: bold; text-align: center">{{ formatMonth(currentTime.split('-')[1]) }}</span>

                                        <span :style="{ 'font-size': bigScreen ? '14px' : '12.4898px', 'margin-top': bigScreen ? '10px' : '4px' }" style="color: rgba(0, 0, 0, 0.5)">{{ currentTime.split('-')[0] }}</span>
                                    </div>
                                    <div style="width: 20px; height: 100%; cursor: pointer">
                                        <img :style="{ width: bigScreen ? '14px' : '10px', height: bigScreen ? '14px' : '10px', 'margin-top': bigScreen ? '18px' : '8px' }" src="/images/w-imgs/portal/right-o.png" @click="nextWeek" />
                                    </div>
                                </div>
                            </td>
                            <td v-for="j in 7" :key="j" :style="{ height: bigScreen ? '92px' : '68px' }" :class="[{ nowDay: dateListData[j - 1].data == chooseDate }, { select: dateListData[j - 1].data == chooseDate }]" @click="choose(dateListData[j - 1])">
                                <div style="display: flex; flex-direction: column; height: 100%">
                                    <span :style="{ 'font-size': bigScreen ? '18px' : '16px', 'margin-top': bigScreen ? '10px' : '' }">{{ dateListData[j - 1].date }}</span>
                                    <span class="weekData" :style="{ 'font-size': bigScreen ? '16px' : '14px', 'margin-top': bigScreen ? '8px' : '5px' }">{{ dateListData[j - 1].week }}</span>
                                    <el-popover v-if="dateListData[j - 1].flag || dateListData[j - 1].dsj" placement="top" width="105" trigger="hover" popper-class="pro-calendar">
                                        <div v-if="dateListData[j - 1].dsj" class="potop">
                                            <span class="left-radius" style="background: rgba(0, 158, 247, 0.35)" />
                                            <span v-text-lbl="'memorabilia'">大事记</span>
                                        </div>
                                        <div v-if="dateListData[j - 1].flag" class="potop">
                                            <span class="left-radius" style="background: rgba(247, 100, 0, 0.35)" />

                                            <span v-text-lbl="'meeting'">会议</span>
                                        </div>
                                        <div slot="reference" class="ho" style="width: 70%; height: 10px; align-items: center; justify-content: space-around; display: flex; position: absolute; bottom: 7px; transform: translateX(-50%); left: 50%">
                                            <span v-if="dateListData[j - 1].dsj" class="dsj" :style="{ background: dateListData[j - 1].data == chooseDate ? 'white' : 'rgba(0, 158, 247, 0.35)', width: bigScreen ? '8px' : '6px', height: bigScreen ? '8px' : '6px' }" style="background: rgba(0, 158, 247, 0.35); border-radius: 50%" />
                                            <span v-if="dateListData[j - 1].flag" class="hy" :style="{ background: dateListData[j - 1].data == chooseDate ? 'white' : 'rgba(247, 100, 0, 0.35)', width: bigScreen ? '8px' : '6px', height: bigScreen ? '8px' : '6px' }" style="background: rgba(247, 100, 0, 0.35); border-radius: 50%" />
                                        </div>
                                    </el-popover>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="!weekType" class="month-content">
                <div class="top">
                    <div class="top-button">
                        <div class="left-title" style="font-size: 18px">
                            <span>{{ yearAndMonth }}</span>
                        </div>
                        <div class="right-button">
                            <span class="left-o" @click="preMonth">
                                <i style="font-size: 12px" class="el-icon-arrow-left" />
                            </span>
                            <span style="margin-left: 20px" class="right-o" @click="nextMonth">
                                <i style="font-size: 12px" class="el-icon-arrow-right" />
                            </span>
                        </div>
                    </div>
                    <table border="0" class="tableMonth-box">
                        <thead>
                            <tr>
                                <td v-for="(item, index) in 7" :key="index" style="color: #b9b7b7" :style="{ fontSize: bigScreen ? '17px' : '14px' }">
                                    {{ monthData[item - 1] }}
                                </td>
                            </tr>
                        </thead>
                        <tbody v-if="dateListData.length > 0">
                            <tr v-for="i in 5" :key="i" :class="i == 4 ? 'trWeek' : ''">
                                <td
                                    v-for="j in 7"
                                    :key="j"
                                    :class="[
                                        {
                                            notCurrentMonth: !notCurrentDate((i - 1) * 7 + (j - 1))
                                        }
                                    ]"
                                    @click="monthChose(dateListData[(i - 1) * 7 + (j - 1)])"
                                >
                                    <div class="box-div" :class="[{ nowDay: dateListData[(i - 1) * 7 + (j - 1)].data == chooseDate }, { select: dateListData[(i - 1) * 7 + (j - 1)].data == chooseDate }]">
                                        <span style="font-size: 17px">
                                            {{ dateListData[(i - 1) * 7 + (j - 1)].date }}
                                        </span>
                                        <el-popover v-if="dateListData[(i - 1) * 7 + (j - 1)].dsj || dateListData[(i - 1) * 7 + (j - 1)].flag" placement="top" width="105" trigger="hover" popper-class="pro-detail">
                                            <div v-if="dateListData[(i - 1) * 7 + (j - 1)].dsj" class="potop">
                                                <span class="left-radius" style="background: rgba(0, 158, 247, 0.35)" />
                                                <span v-text-lbl="'memorabilia'">大事记</span>
                                            </div>
                                            <div v-if="dateListData[(i - 1) * 7 + (j - 1)].flag" class="potop">
                                                <span class="left-radius" style="background: rgba(247, 100, 0, 0.35)" />
                                                <span v-text-lbl="'meeting'">会议</span>
                                            </div>
                                            <div slot="reference" style="height: 13px; width: 40%; align-items: center; justify-content: space-around; display: flex; position: absolute; bottom: 0px; transform: translateX(-50%); left: 50%">
                                                <span v-if="dateListData[(i - 1) * 7 + (j - 1)].dsj" :style="{ background: dateListData[(i - 1) * 7 + (j - 1)].data == chooseDate ? 'white' : 'rgba(0, 158, 247, 0.35)' }" style="background: rgba(0, 158, 247, 0.35); border-radius: 50%; width: 6px; height: 6px" />
                                                <span v-if="dateListData[(i - 1) * 7 + (j - 1)].flag" class="hy" :style="{ background: dateListData[(i - 1) * 7 + (j - 1)].data == chooseDate ? 'white' : 'rgba(247, 100, 0, 0.35)' }" style="background: rgba(247, 100, 0, 0.35); border-radius: 50%; width: 6px; height: 6px" />
                                            </div>
                                        </el-popover>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- 切换模式 -->
            <div>
                <el-divider>
                    <el-tooltip class="item" effect="dark" :content="weekType ? $tx('ecoa.portal.switchMonth', '切换月模式') : $tx('ecoa.portal.switchWeek', '切换周模式')" placement="top">
                        <svg-icon v-if="!weekType" icon-class="shouqi" style="cursor: pointer" @click="changType" />
                        <svg-icon v-if="weekType" icon-class="zhankai" style="cursor: pointer" @click="changType" />
                    </el-tooltip>
                </el-divider>
            </div>
            <div class="schedule-list">
                <div v-if="incidentsList.length > 0 && finallyData.length > 0" class="schedule-title">
                    <div class="titleOne">
                        <span class="spanO-title">
                            <span v-text-lbl="'memorabilia'">大事记</span>
                            <span class="spanO-point">！</span>
                        </span>
                        <span style="margin-left: 15px"><i v-for="(item, index) in 4" :key="index" style="font-size: 16px; width: 8px; font-weight: bold" class="el-icon-arrow-right" /></span>
                    </div>
                    <div class="title-two">
                        <span class="spanT-title">{{ incidentsList[0].title }}</span>
                        <span v-if="incidentsList[0].url" class="spanT-title2" @click="gotoDetail(incidentsList[0])">
                            <span v-pageBtn-lbl="'lookDetails'">查看详情</span>
                            <i class="el-icon-arrow-right" />
                        </span>
                    </div>
                </div>
                <div class="schedule-content" :style="{ height: scrollerHeight }">
                    <div v-for="(item, index) in finallyData" :key="index" class="content-list">
                        <div class="content-time">{{ item.title }}</div>
                        <div v-if="item.timeDate == nowLine().hours" style="width: calc(100% - 45px)" :style="{ height: '20px', position: 'absolute', 'z-index': 22, 'line-height': '20px', right: '0', top: nowLine().minutes - 10 + 'px' }">
                            <span style="font-size: 12px; color: var(--subjectColor); position: absolute; right: 2px">{{ nowLine().time }}</span>
                            <span style="height: 0; position: absolute; right: 32px; top: 5px; width: 0; display: inline-block; border-left: 5px solid transparent; border-top: 5px solid transparent; border-bottom: 5px solid transparent; border-right: 5px solid var(--subjectColor)" />
                            <span style="width: calc(100% - 35px); display: inline-block; height: 1px; background: var(--subjectColor); position: absolute; top: 10px; left: 0; z-index: 222" />
                        </div>
                        <div class="content-val">
                            <template v-if="item.valData.length == 1 && !item.valData[0].isEnd">
                                <div v-for="(val, indexA) in item.valData" :key="indexA" class="content-item" :style="{ left: '5px', height: val.timeHeight + 'px', top: val.startHeight + 'px', width: '98%', 'line-height': val.timeHeight + 'px' }">
                                    <proDetail :list-detail="val.listDetail">
                                        <template #p-title>
                                            <span>{{ val.listDetail.title }}</span>
                                        </template>
                                    </proDetail>
                                </div>
                            </template>
                            <template v-if="item.valData.length == 1 && item.valData[0].isEnd">
                                <div v-for="(val, indexA) in item.valData" :key="indexA" class="content-item" :class="val.isEnd ? 'isOver' : ''" :style="{ left: '5px', height: val.timeHeight + 'px', top: val.startHeight + 'px', width: '98%', display: 'flex', 'text-decoration': 'line-through', background: '#F6F6F5', border: '0.5px solid rgba(228, 230, 236, 0.8)', color: 'gray' }">
                                    <proDetail :list-detail="val.listDetail">
                                        <template #p-title>
                                            <span>{{ val.listDetail.title }}</span>
                                            <span class="spanEnd">
                                                <span v-text-lbl="'Ended'" style="font-size: 20px; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%) scale(0.5)">已结束</span>
                                            </span>
                                        </template>
                                    </proDetail>
                                </div>
                            </template>
                            <template v-if="item.valData.length > 1">
                                <template v-for="(val, indexB) in item.valData">
                                    <div v-if="!val.isEnd" :key="indexB" class="content-item" :style="{ height: val.timeHeight + 'px', top: val.startHeight + 'px', left: indexB * 125 + 5 + 'px', 'line-height': val.timeHeight + 'px' }">
                                        <proDetail :list-detail="val.listDetail">
                                            <template #p-title>
                                                <span>{{ val.listDetail.title }}</span>
                                            </template>
                                        </proDetail>
                                    </div>
                                    <div v-if="val.isEnd" :key="indexB" class="content-item isOver" :style="{ 'text-decoration': 'line-through', background: '#F6F6F5', border: '0.5px solid rgba(228, 230, 236, 0.8)', color: 'gray', height: val.timeHeight + 'px', top: val.startHeight + 'px', left: indexB * 125 + 5 + 'px', 'line-height': val.timeHeight + 'px' }">
                                        <proDetail :list-detail="val.listDetail">
                                            <template #p-title>
                                                <span>{{ val.listDetail.title }}</span>
                                                <span class="spanEnd">
                                                    <span v-text-lbl="'Ended'" style="font-size: 20px; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%) scale(0.5)">已结束</span>
                                                </span>
                                            </template>
                                        </proDetail>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </CCBlockFrame>
    </div>
</template>
<script>
import proDetail from './calendarUtil/proDetail.vue'
const calendarUtil = require('@/global/utils/calendarUtil.js').default
const moment = require('moment')
import { mapGetters } from 'vuex'
export default {
    components: {
        proDetail
    },
    props: {
        title: { type: String, default: '' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'ecoa',
            moduleCode: 'calendar',
            weekData: ['日', '一', '二', '三', '四', '五', '六'],
            // monthData: ['一', '二', '三', '四', '五', '六', '日'],
            monthData: [this.$tx('ecoa.calender.one', '一'), this.$tx('ecoa.calender.two', '二'), this.$tx('ecoa.calender.three', '三'), this.$tx('ecoa.calender.four', '四'), this.$tx('ecoa.calender.five', '五'), this.$tx('ecoa.calender.six', '六'), this.$tx('ecoa.calender.seven', '日')],
            timeData: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
            isSelect: '',
            listData: [],
            currentTime: this.getCurrentDateTime(),
            showCurrentTime: this.getCurrentDateTime(),
            currentHours: this.getCurrentTime(),
            chooseDate: this.getCurrentDateTime(),
            whereWeek: '',
            weekType: false,
            scheduleData: [],
            incidentsList: [],
            finallyData: [],
            dateListData: [],
            incidents: [],
            canlendarData: [],
            canlendarMonthData: [],
            scrollerHeight: '',
            bigScreen: false,
            yearAndMonth: moment(this.currentTime).format('YYYY年MM月')
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {
        currentTime(val) {
            if (val) {
                // this.yearAndMonth = val.split('-')[0] + '年' + val.split('-')[1] + '月'
                this.yearAndMonth = this.$tx('ecoa.calendar.yearAMonth', { year: val.split('-')[0], month: val.split('-')[1] }, '{year}年{month}月')
            }
        }
    },
    created() {
        if (this.weekType) {
            this.initWeekData()
        } else {
            this.initMonthData()
        }
    },
    mounted() {
        // console.log(291, document.getElementById('newCalendarBox').offsetParent.offsetParent.clientHeight)
        this.scrollerHeight = document.getElementById('newCalendarBox').offsetParent.offsetParent.clientHeight - 438 + 'px'
        // 适配大屏小屏
        this.getWindowInfo()
        window.addEventListener('resize', this.getWindowInfo)
        this.title = this.title || this.$tx('ecoa.calendar.personalSchedule', '个人日程')
    },
    destroyed() {
        window.removeEventListener('resize', this.getWindowInfo)
    },
    methods: {
        formatMonth(index) {
            let months = ['', this.$tx('ecoa.common.one', '1月'), this.$tx('ecoa.common.two', '2月'), this.$tx('ecoa.common.three', '3月'), this.$tx('ecoa.common.four', '4月'), this.$tx('ecoa.common.five', '5月'), this.$tx('ecoa.common.six', '6月'), this.$tx('ecoa.common.seven', '7月'), this.$tx('ecoa.common.eight', '8月'), this.$tx('ecoa.common.nine', '9月'), this.$tx('ecoa.common.ten', '10月'), this.$tx('ecoa.common.eleven', '11月'), this.$tx('ecoa.common.twelve', '12月')]
            return months[index]
        },
        forMat(time) {
            const week = ['日', '一', '二', '三', '四', '五', '六']
            const date = new Date(time)
            const weekDate = '周' + week[date.getDay()]
            const dateTime = date.getMonth() + 1 + '月' + date.getDate() + '号'
            return {
                weekDate,
                dateTime
            }
        },
        // 切换模式
        changType() {
            this.weekType = !this.weekType
            if (this.weekType) {
                this.initWeekData()
                if (this.bigScreen) {
                    this.scrollerHeight = document.getElementById('newCalendarBox').offsetParent.offsetParent.clientHeight - 206 + 'px'
                } else {
                    this.scrollerHeight = document.getElementById('newCalendarBox').offsetParent.offsetParent.clientHeight - 198 + 'px'
                }
            } else {
                this.initMonthData()
                this.scrollerHeight = document.getElementById('newCalendarBox').offsetParent.offsetParent.clientHeight - 438 + 'px'
            }
        },
        // 适配
        getWindowInfo() {
            if (document.body.clientWidth > 1600) {
                this.bigScreen = true
            } else {
                this.bigScreen = false
            }
        },
        // 大事记详情
        gotoDetail(item) {
            const activeItem = {
                name: '新闻',
                type: 2,
                moduleInfo: { getByIdUrl: '/portal/cms/article/getById' },
                fieldInfo: { timeField: 'publishTime', senderField: 'creator', titleField: 'title', contField: 'content' },
                desInfo: { timeDes: '时间：', senderDes: '发布人：' }
            }
            window.open('#/listinfo?rowId=' + item.id + '&pageCode=ListInfo&activeItem=' + encodeURIComponent(JSON.stringify(activeItem)))
        },
        // 当前时间刻度
        nowLine() {
            var d = new Date()
            var hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
            var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
            var time = hours + ':' + minutes
            return {
                hours,
                minutes,
                time
            }
        },
        notCurrentDate(index) {
            return this.listData[index].name === 'nowMonth'
        },
        preMonth() {
            let year = new Date(this.currentTime).getFullYear()
            let month = new Date(this.currentTime).getMonth() + 1
            if (month <= 1) {
                this.listData = calendarUtil.createNowMonthDate(--year, '12')
                this.getMonthListData(this.listData[0].data, this.listData[this.listData.length - 1].data, this.listData, this.currentTime)
                this.currentTime = year + '-' + 12
                this.MonthTitle = moment(this.currentTime).format('YYYY年MM月')
            } else {
                this.listData = calendarUtil.createNowMonthDate(year, --month < 10 ? '0' + month : month)
                this.getMonthListData(this.listData[0].data, this.listData[this.listData.length - 1].data, this.listData, this.currentTime)
                this.currentTime = year + '-' + (month < 10 ? '0' + month : month)
                this.MonthTitle = moment(this.currentTime).format('YYYY年MM月')
            }
        },
        nextMonth() {
            let year = new Date(this.currentTime).getFullYear()
            let month = new Date(this.currentTime).getMonth() + 1
            if (month >= 12) {
                this.listData = calendarUtil.createNowMonthDate(++year, '01')
                this.getMonthListData(this.listData[0].data, this.listData[this.listData.length - 1].data, this.listData, this.currentTime)
                this.currentTime = year + '-' + '01'
                this.MonthTitle = moment(this.currentTime).format('YYYY年MM月')
            } else {
                this.listData = calendarUtil.createNowMonthDate(year, ++month < 10 ? '0' + month : month)
                this.getMonthListData(this.listData[0].data, this.listData[this.listData.length - 1].data, this.listData, this.currentTime)
                this.currentTime = year + '-' + (month < 10 ? '0' + month : month)
                this.MonthTitle = moment(this.currentTime).format('YYYY年MM月')
            }
        },
        // 月模式初始化数据
        initMonthData(time) {
            this.currentTime = time || this.currentTime
            const val = this.currentTime.split('-')
            this.listData = calendarUtil.createNowMonthDate(val[0], val[1])
            this.getMonthListData(this.listData[0].data, this.listData[this.listData.length - 1].data, this.listData, this.currentTime) // 获取一月的日程数据
        },
        // 周模式初始化数据
        initWeekData(time) {
            this.listData = []
            this.currentTime = time || this.currentTime
            this.listData = calendarUtil.getNowWeekDay(this.currentTime) // 获取日历
            this.getWeekListData(this.listData[0].data, this.listData[6].data, this.listData, this.currentTime) // 获取一周的日程数据
            this.whereWeek = calendarUtil.getWeekOnYears(this.currentTime) // 第几周
        },
        // 获取一月的日程数据
        async getMonthListData(start, end, listdata, currentTime) {
            // 获取一个月的日程数据
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                const defaultData = await this.$getDefaultData(this, this.appletData.id)
                const incidents = defaultData.grrcMonthListData.incidents
                const canlendarMonthData = defaultData.grrcMonthListData.canlendarMonthData
                if (this.appletData.name === '个人日程') {
                    this.incidents = incidents
                    this.canlendarMonthData = canlendarMonthData
                    this.dateListData = this.arrayAdapter(listdata, this.canlendarMonthData, currentTime, this.incidents).dateListData
                    this.finallyData = this.arrayAdapter(listdata, this.canlendarMonthData, currentTime, this.incidents).finallyData // 获取日程数据结构
                    // const scrlloBox = document.querySelector('.schedule-content')
                    // if (scrlloBox) {
                    //     this.$nextTick(() => {
                    //         scrlloBox.scrollTop = this.nowLine().hours * 60 - 60
                    //     })
                    // }
                    // console.log(462, this.incidents, this.canlendarMonthData, currentTime, listdata)
                    return
                }
            }
            this.$http({
                method: 'post',
                params: {
                    startdate: moment(start).format('YYYY-MM-DD') + ' ' + '00:00:00',
                    enddate: moment(end).format('YYYY-MM-DD') + ' ' + '23:59:59'
                },
                url: '/ecoa/calendar/dayView'
            }).then((res) => {
                if (res.code === 'success') {
                    // this.$http({
                    //     method: 'POST',
                    //     data: [{ compare: '=', field: 'type', merge: true, value: '3' }],
                    //     url: '/portal/cms/article/querydata'
                    // }).then((resp) => {
                    //     if (resp.code === 'success') {
                    // this.incidents = resp.body.listdata
                    this.incidents = []
                    this.canlendarMonthData = res.body.calendarList
                    this.dateListData = this.arrayAdapter(listdata, this.canlendarMonthData, currentTime, this.incidents).dateListData
                    this.finallyData = this.arrayAdapter(listdata, this.canlendarMonthData, currentTime, this.incidents).finallyData // 获取日程数据结构
                    if (this.incidents.length > 0) {
                        this.incidentsList = this.incidents.filter((val) => {
                            return val.publishTime && val.publishTime.split(' ')[0] === currentTime
                        })
                    }
                    console.log(462, this.incidents, this.canlendarMonthData, currentTime, listdata)
                    const scrlloBox = document.querySelector('.schedule-content')
                    if (scrlloBox) {
                        this.$nextTick(() => {
                            scrlloBox.scrollTop = this.nowLine().hours * 60 - 60
                        })
                    }
                    //     }
                    // })
                }
            })
        },
        // 获取一周的日程数据
        async getWeekListData(start, end, listdata, currentTime) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                const defaultData = await this.$getDefaultData(this, this.appletData.id)
                const incidents = defaultData.grrcWeekListData.incidents
                const canlendarData = defaultData.grrcWeekListData.canlendarData
                if (this.appletData.name === '个人日程') {
                    this.incidents = incidents
                    this.canlendarData = canlendarData
                    this.dateListData = this.arrayAdapter(listdata, this.canlendarData, currentTime, this.incidents).dateListData
                    this.finallyData = this.arrayAdapter(listdata, this.canlendarData, currentTime, this.incidents).finallyData // 获取日程数据结构
                    // const scrlloBox = document.querySelector('.schedule-content')
                    // if (scrlloBox) {
                    //     this.$nextTick(() => {
                    //         scrlloBox.scrollTop = this.nowLine().hours * 60 - 60
                    //     })
                    // }
                    console.log(507, this.incidents, this.canlendarData, currentTime, listdata)
                    return
                }
            }
            this.$http({
                method: 'POST',
                params: {
                    startdate: moment(start).format('YYYY-MM-DD') + ' ' + '00:00:00',
                    enddate: moment(end).format('YYYY-MM-DD') + ' ' + '23:59:59'
                },
                url: '/ecoa/calendar/dayView'
            }).then((res) => {
                if (res.code === 'success') {
                    // this.$http({
                    //     method: 'POST',
                    //     data: [{ compare: '=', field: 'type', merge: true, value: '3' }],
                    //     url: '/portal/cms/article/querydata'
                    // }).then((resp) => {
                    //     if (resp.code === 'success') {
                    //         this.incidents = resp.body.listdata
                    this.incidents = []
                    this.canlendarData = res.body.calendarList
                    this.finallyData = this.arrayAdapter(listdata, this.canlendarData, currentTime, this.incidents).finallyData // 获取日程数据结构
                    this.dateListData = this.arrayAdapter(listdata, this.canlendarData, currentTime, this.incidents).dateListData
                    if (this.incidents.length > 0) {
                        this.incidentsList = this.incidents.filter((val) => {
                            return val.publishTime && val.publishTime.split(' ')[0] === currentTime
                        })
                    }
                    console.log(507, this.incidents, this.canlendarData, currentTime, listdata)
                    const scrlloBox = document.querySelector('.schedule-content')
                    if (scrlloBox) {
                        this.$nextTick(() => {
                            scrlloBox.scrollTop = this.nowLine().hours * 60 - 60
                        })
                    }
                    //     }
                    // })
                }
            })
        },
        // 组件日程列表数据
        arrayAdapter(arrayA, arrayB, current, incidents) {
            // 1日历数据，2日程数据,3当天日期 4 大事记数据
            this.scheduleData = []
            arrayA.forEach((item, index) => {
                if (arrayB.length > 0) {
                    arrayB.forEach((val) => {
                        if (item.data === val.date) {
                            item.flag = true
                            val.listDetail.forEach((el) => {
                                if (current === val.date) {
                                    const timeHeight = this.timeDiff(this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).start, this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).end).minutes
                                    const hours = this.timeDiff(this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).start, this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).end).hours
                                    const time = this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).time
                                    let startHeight = this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).startHeight
                                    startHeight = Math.floor(hours) === hours ? startHeight - 0 + 5 : startHeight
                                    const endTime = this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).end
                                    this.scheduleData.push({
                                        timeHeight: timeHeight,
                                        time: time,
                                        listDetail: el,
                                        date: val.date,
                                        isEnd: new Date(endTime).getTime() < new Date().getTime(),
                                        startHeight: startHeight
                                    })
                                }
                            })
                        } else if (!val.date) {
                            item.flag = true
                            val.listDetail.forEach((el) => {
                                if (index === 0) {
                                    const timeHeight = this.timeDiff(this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).start, this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).end).minutes
                                    const hours = this.timeDiff(this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).start, this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).end).hours
                                    const time = this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).time
                                    let startHeight = this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).startHeight
                                    startHeight = Math.floor(hours) === hours ? startHeight - 0 + 5 : startHeight
                                    const endTime = this.timeFor(el.startDate, el.endDate, el.startTime, el.endTime).end
                                    this.scheduleData.push({
                                        timeHeight: timeHeight,
                                        time: time,
                                        listDetail: el,
                                        date: val.date,
                                        isEnd: new Date(endTime).getTime() < new Date().getTime(),
                                        startHeight: startHeight
                                    })
                                }
                            })
                        }
                    })
                }
            })
            // 大事记在日程中显示
            arrayA.forEach((arry) => {
                if (incidents.length > 0) {
                    incidents.forEach((init) => {
                        if (init.publishTime && arry.data === init.publishTime.split(' ')[0]) {
                            arry.dsj = true
                        }
                    })
                }
            })
            let allTime = {}
            let num = 1
            const showData = []
            // 组装时间刻度数组
            this.timeData.forEach((data) => {
                allTime = {
                    timeDate: num < 10 ? '0' + num : num + '',
                    title: data
                }
                num++
                showData.push(allTime)
            })
            // 把日程数据添加到对应的时间刻度
            showData.forEach((item) => {
                const tempData = []
                if (this.scheduleData.length > 0) {
                    this.scheduleData.forEach((val) => {
                        if (item.timeDate === val.time) {
                            tempData.push(val)
                        }
                    })
                }
                item.valData = tempData
            })
            // 返回时间刻度数据和渲染的一周日程
            return {
                finallyData: showData,
                dateListData: arrayA
            }
        },
        // 计算结束时间和开始时间相差的分钟和小时
        timeDiff(startTime, endTime) {
            const start = new Date(startTime).getTime()
            const end = new Date(endTime).getTime()
            const val = Number(end) - Number(start)
            let minutes = ''
            minutes = val / 1000 / 60 - 10 // -10 为了美观 在页面上渲染不占满
            const hours = val / 1000 / 60 / 60
            return {
                minutes,
                hours
            }
        },
        // 获取开始时间刻度，距离当前刻度偏移量
        timeFor(startDate, endDate, startTime, endTime) {
            const time = startTime.split(':')[0]
            const startHeight = startTime.split(':')[1] - 0
            const start = startDate + ' ' + startTime.split(':')[0] + ':' + startTime.split(':')[1]
            const end = endDate + ' ' + endTime.split(':')[0] + ':' + endTime.split(':')[1]
            return {
                time,
                startHeight,
                start,
                end
            }
        },
        // 获取当前是几点
        getCurrentTime() {
            var d = new Date()
            return d.getHours()
        },
        // 当前时间格式化
        getCurrentDateTime() {
            var d = new Date()
            var year = d.getFullYear()
            var month = d.getMonth() + 1
            var date = d.getDate()
            var curDateTime = ''
            curDateTime = year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date)
            return curDateTime
        },
        // 判断是否是当天
        nowDay(val) {
            const date = this.getCurrentDateTime()
            return val === date
        },
        // 判断是否选中
        select(item) {
            return item.data === this.chooseDate
        },
        monthChose(item) {
            this.incidentsList = []
            this.chooseDate = item.data
            this.getMonthListData(item.data, item.data, this.listData, item.data)
        },
        // 选中日期
        choose(item) {
            this.incidentsList = []
            this.chooseDate = item.data
            this.getWeekListData(item.data, item.data, this.listData, item.data) // 获取一周的日程数据
        },
        // 上周
        preWeek() {
            this.listData = calendarUtil.getLastWeekDay(this.currentTime).lastWeekArray
            this.currentTime = calendarUtil.getLastWeekDay(this.currentTime).newDay
            this.getWeekListData(this.listData[0].data, this.listData[6].data, this.listData)
            this.whereWeek = calendarUtil.getWeekOnYears(this.currentTime)
        },
        // 下周
        nextWeek() {
            this.listData = calendarUtil.getNextWeekDay(this.currentTime).nextWeekArray
            this.currentTime = calendarUtil.getNextWeekDay(this.currentTime).newDay
            this.getWeekListData(this.listData[0].data, this.listData[6].data, this.listData)
            this.whereWeek = calendarUtil.getWeekOnYears(this.currentTime)
        }
    }
}
</script>
  <style lang="scss">
.pro-calendar {
    border-radius: 8px !important;
}
.mainCalendar-detail {
    border-radius: 8px !important;
    .proTime {
        .pro-title {
            height: 40px;
            overflow: hidden;
            font-size: 12px;
            line-height: 40px;
            position: relative;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-bottom: 1px solid #ebebeb;
        }
    }
}
</style>
  <style scoped lang="scss">
.potop {
    width: 100%;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    .left-radius {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 5px;
    }
}
.top {
    margin: 0 auto;
    width: 100%;
    // padding: 0px 0 30px 0;
    .top-content {
        padding: 0px 15px;
        .top-one {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            :first-child {
                width: 38px;
                height: 22px;
                display: inline-block;
                font-size: 13px;
                background: #ff6a00;
                font-weight: 500;
                color: white;
                border-radius: 4px;
                text-align: center;
                line-height: 22px;
                transform: skewX(-10deg);
            }
            :last-child {
                font-weight: 500;
                font-size: 18px;
                line-height: 25px;
                color: #262626;
                margin-left: 12px;
            }
        }
        .top-two {
            display: flex;
            height: 50px;
            align-items: center;
            .top-now {
                width: 39px;
                height: 44px;
                background: white;
                border-radius: 7px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
            .top-text {
                width: 90%;
                height: 100%;
                padding-left: 20px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                color: white;
            }
        }
    }
}
.table-box {
    margin: 0 auto;
    width: 100%;
    .select-button {
        width: 88px;
    }
    .select-button:hover {
        // border: 1px solid transparent;
        box-shadow: none;
        background: #fcfcfc;
    }
}
.select-card {
    position: absolute;
    top: 10px;
    left: 30%;
    width: 115px;
    height: 52px;
}
.select-month {
    position: absolute;
    top: 72px;
    left: 26%;
    width: 240px;
    height: 135px;
    z-index: 999;
    background: white;
    animation: box 0.3s;
}
@keyframes box {
    0% {
        top: 50px;
        height: 50px;
    }
    100% {
        top: 72px;
        height: 135px;
    }
}
.select-month span:hover {
    cursor: pointer;
}
.select-month::before {
    content: '';
    width: 0;
    height: 0;
    top: -20px;
    left: 50%;
    position: absolute;
    border-top: 10px solid transparent;
    border-bottom: 10px solid white;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
}
.select-card .card-content {
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.select-card .card-content img {
    width: 25px;
    height: 25px;
}
.table-box td {
    height: 68px;
    width: 38px;
    border-radius: 12px;
    background: #fcfcfc;
    text-align: center;
}
.table-box tr td:hover {
    cursor: pointer;
    border-radius: 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
}
.weekData {
    color: rgba(0, 0, 0, 0.45);
    opacity: 0.6;
}
.festivalData {
    color: rgba(240, 36, 36, 0.45);
}
.table-box tr > td {
    color: black;
    font-weight: bold;
    font-size: 14px;
    padding: 5px 2px;
    position: relative;
}
.table-box .nowDay {
    color: white;
    background: var(--bgColor);
}
.table-box .nowDay .weekData {
    color: white;
    opacity: 1;
}
.table-box .notCurrentMonth {
    color: gray;
    position: relative;
}
.table-box .select {
    background: var(--bgColor);
    color: white;
}
.table-box .select .weekData {
    color: white;
    opacity: 1;
}
.schedule-list {
    top: 10px;
    width: 100%;
    height: 620px;
    background: white;
    //  box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.06);
    margin: 0 auto;
    position: relative;
    transform-style: preserve-3d;
    perspective: 2000px;
    border-radius: 12px;
}
.foot {
    position: absolute;
    bottom: 18px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
}
.foot-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
    height: 1px;
    width: 12px;
    margin-top: 6px;
    margin-right: 10px;
}
.foot-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
    height: 1px;
    width: 12px;
    margin-top: 6px;
    margin-left: 10px;
}
.schedule-list .schedule-title {
    width: 100%;
    height: 80px;
    padding: 0 20px;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .titleOne {
        .spanO-title {
            position: relative;
            font-weight: bold;
            font-size: 16px;
            color: rgba(16, 16, 16, 0.75);
            text-shadow: 0px 2px 4px rgba(147, 147, 147, 0.25);
            .spanO-point {
                position: absolute;
                font-size: 18px;
                color: rgba(16, 16, 16, 0.75);
                text-shadow: 0px 2px 4px rgba(147, 147, 147, 0.25);
                transform: rotate(15deg);
            }
        }
    }
    .title-two {
        margin-top: 10px;
        display: flex;
        align-items: center;
        .spanT-title {
            color: #121010;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            width: 240px;
            text-overflow: ellipsis;
            display: inline-block;
        }
        .spanT-title2 {
            color: rgba(72, 72, 72, 0.5);
            font-size: 12px;
            cursor: pointer;
            margin-left: 15px;
        }
        .spanT-title2:hover {
            color: var(--bgColor);
        }
    }
}
.schedule-list .schedule-content::-webkit-scrollbar {
    width: 6px;
}
.schedule-content::-webkit-scrollbar-thumb {
    background-color: #c6c6c6;
    border-radius: 10px;
}
.schedule-content::-webkit-scrollbar-track {
    background-color: #f5f5f5;
}
.schedule-list .schedule-content {
    overflow-y: scroll;
    width: 100%;
    height: 540px;
    padding: 10px 20px 0 20px;
    background: white;
    position: absolute;
    left: 0;
    transform-origin: left;
    border-radius: 12px;
}
.content-list {
    height: 60px;
    width: 100%;
    display: flex;
    position: relative;
}
.content-list .content-time {
    font-size: 12px;
    color: #c1c8d2;
    width: 50px;
    height: 100%;
    position: relative;
    top: -6px;
}
.content-list .content-val {
    height: 100%;
    width: 100%;
    position: relative;
    padding: 2px;
    border-top: 1px solid #f0f0f0;
}
.content-list .content-val .content-item::before {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: 4px;
    left: 0;
    background: var(--bgColor);
}
.content-list .content-val .isOver::before {
    content: '';
    display: none;
}
.content-list .content-val .isOver .spanEnd {
    position: absolute;
    color: gray;

    width: 44px;
    height: 16px;
    background: #f9f9f9;
    text-align: center;
    right: 0px;
    top: 0px;
    border-bottom: 0.5px solid rgba(228, 230, 236, 0.8);
    border-left: 0.5px solid rgba(228, 230, 236, 0.8);
    border-radius: 0 0 0 5px;
}
.content-list .content-val .content-item {
    padding: 0 10px;
    width: 120px;
    height: 50px;
    background: linear-gradient(180deg, #fffffc -14.29%, #f4f5ff 29.58%, #f0f3ff 100%);
    position: absolute;
    border-radius: 5px;
    left: 10px;
    top: 0px;
    z-index: 99;
    color: var(--bgColor);
    font-size: 14px;
    display: flex;
    align-items: center;
    border: 1px solid;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
}
.month-content {
    width: 100%;
    margin: 0 auto;
    .top {
        margin: 0 auto;
        width: 100%;
        .top-button {
            width: 100%;
            height: 60px;
            padding: 0px 10px 0px 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left-title {
                font-size: 16px;
                font-weight: bold;
                color: #24292b;
            }
            .right-button {
                height: 100%;
                width: 20%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                span {
                    width: 28px;
                    height: 28px;
                    background: #f9f8f8;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
                .left-o:hover {
                    background: var(--subjectColor);
                    color: white;
                }
                .right-o:hover {
                    background: var(--subjectColor);
                    color: white;
                }
            }
        }
        .tableMonth-box {
            margin: 0 auto;
            width: 100%;
            border-spacing: inherit;
            .potop {
                width: 100%;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                display: flex;
                align-items: center;
                position: relative;
                .left-radius {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    margin-right: 5px;
                }
            }
            .select .weekData {
                color: white;
                opacity: 1;
            }
            .select {
                background: var(--bgColor);
                color: white;
            }
            .notCurrentMonth {
                color: rgba(0, 0, 0, 0.4);
                position: relative;
            }
            .nowDay {
                color: white;
                background: var(--subjectColor);
            }
            .nowDay .weekData {
                color: white;
                opacity: 1;
            }
            td {
                height: 34px;
                width: 38px;
                border-radius: 8px;
                text-align: center;
                color: black;
                font-size: 16px;
                position: relative;
                .box-div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin: 0 auto;
                    height: 100%;
                    width: 40px;
                    border-radius: 8px;
                    &:hover {
                        cursor: pointer;
                        background: #dcebfd;
                    }
                }
            }
        }
    }
}
</style>

